import PropTypes from 'prop-types';

import { noop } from 'shared_DEPRECATED/utils/function';

import { VARIANTS } from 'shared/components/Button';
import { ModalButton } from 'shared/components/Modal/ModalButton';

const FrequencyDialogButtonsPropTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  shouldCloseOnSubmit: PropTypes.bool,
};

export const FrequencyDialogButtons = ({
  onSave,
  onCancel = noop,
  shouldCloseOnSubmit = true,
}) => (
  <>
    <ModalButton
      variant="outline"
      onClick={onCancel}
      dataTestid="challenge-frequency-dialog-cancel"
      shouldClose={shouldCloseOnSubmit}
    >
      Cancel
    </ModalButton>
    <ModalButton
      onClick={onSave}
      color={VARIANTS.PRIMARY}
      dataTestid="challenge-frequency-dialog-save"
      shouldClose={shouldCloseOnSubmit}
    >
      Save
    </ModalButton>
  </>
);

FrequencyDialogButtons.propTypes = FrequencyDialogButtonsPropTypes;
